"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarSegmentButton = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SidebarSegmentButton = function (_a) {
    var selected = _a.selected, label = _a.label, IconComponent = _a.iconComponent;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxs" },
        react_1.default.createElement(IconComponent, { color: selected ? "primary" : "default" }),
        react_1.default.createElement(kaleidoscope_1.Text, { secondary: !selected, size: "s" }, label)));
};
exports.SidebarSegmentButton = SidebarSegmentButton;
